import * as correspondentTaskAction from './action';
const initialState = {
    taskDetailsSuccess: [],
    taskDetailsFailure: [],
    downloadAllTaskSuccess: [],
    downloadAllTaskFailure: [],
    downloadTaskSuccess: [],
    downloadTaskFailure: [],
    uploadTaskSuccess: [],
    uploadTaskFailure: []
}
const correspondentTaskReducer = (state = initialState, action) => {
    switch (action.type) {
        case correspondentTaskAction.FETCH_TASK_DETAILS_SUCCESS:
            return state = {
                ...state,
                taskDetailsSuccess: action.data
            }
        case correspondentTaskAction.FETCH_TASK_DETAILS_FAILURE:
            return state = {
                ...state,
                taskDetailsFailure: action.data
            }
        case correspondentTaskAction.DOWNLOAD_ALL_TASK_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                downloadAllTaskSuccess: action.data
            }
        case correspondentTaskAction.DOWNLOAD_ALL_TASK_TEMPLATE_FAILURE:
            return state = {
                ...state,
                downloadAllTaskFailure: action.data
            }
        case correspondentTaskAction.DOWNLOAD_TASK_SUCCESS:
            return state = {
                ...state,
                downloadTaskSuccess: action.data
            }
        case correspondentTaskAction.DOWNLOAD_TASK_FAILURE:
            return state = {
                ...state,
                downloadTaskFailure: action.data
            }
        case correspondentTaskAction.UPLOAD_TASK_SUCCESS:
            return state = {
                ...state,
                uploadTaskSuccess: action.data
            }
        case correspondentTaskAction.UPLOAD_TASK_FAILURE:
            return state = {
                ...state,
                uploadTaskFailure: action.data
            }
        default: return state
    }
}

export default correspondentTaskReducer; 